// **********************************************************
// Tag Collection
// **********************************************************

const tagCollectionTabs = document.querySelectorAll('[data-slider="tag-collection-tabs"]');
const tagCollectionContent = document.querySelectorAll('[data-slider="tag-collection-content"]');

// 1.1 - Tag Collection Tabs Slider
const tagCollectionTabsOptions = {
  slidesPerView: 1.1,
  spaceBetween: 20,
  watchOverflow: true,
  speed: 600,
  breakpoints: {
    767: {
      slidesPerView: 2.1,
      spaceBetween: 20,
    },
    1023: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

tagCollectionTabs.forEach((el) => new Swiper(el, tagCollectionTabsOptions));

// 1.2 - Tag Collection Content Slider
const tagCollectionContentOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  watchOverflow: true,
  allowTouchMove: false,
  autoHeight: true,
  speed: 600,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  thumbs: {
    swiper: false,
  },
};

tagCollectionContent.forEach((el, i) => {
  tagCollectionContentOptions.thumbs.swiper = tagCollectionTabs[i].swiper;
  new Swiper(el, tagCollectionContentOptions);
});
